import React from "react";
import {useSelector} from "react-redux";
import {ProactiveMessagesBox} from "./ProactiveMessagesBox";
import {RetainMessagesBox} from "./RetainMessagesBox";
import useLocationQueryParams from "components/v2/hooks/useLocationQueryParams";
import {RETAIN_CAMPAIGNS} from "../../RetainDashboard/Utilities/CampaignUtils";

export const ProactiveMessagesBoxContainer = ({source, organizationId, pageParams, setPageParams, pageFilter, onFilterFormSubmit, orderBy, sortBy, setOrderBy, setSortBy}) => {
    const proactiveMetricsDetailData = useSelector(state => state.proactive.proactiveMessagesList);
    const loadingProactiveMessagesList = useSelector(state => state.proactive.loadingProactiveMessagesList);
    const {params, setParams} = useLocationQueryParams();

    const filterCampaignToMessageDetails = {
        [pageFilter]: {
            messages: proactiveMetricsDetailData.items,
            count: proactiveMetricsDetailData.totalCount,
            loading: loadingProactiveMessagesList,
            channel: proactiveMetricsDetailData.channel
        }
    }

    const handleSortChange = (sortParams) => {
        const {sortBy, orderBy} = sortParams;

        setSortBy(sortBy);
        setOrderBy(orderBy);
        setParams({...params, ...sortParams});
        onFilterFormSubmit({
            sortBy: sortParams.sortBy,
            orderBy: sortParams.orderBy,
        });
    };

    if(pageFilter === RETAIN_CAMPAIGNS){
        return (
            <RetainMessagesBox
                source={source}
                organizationId={organizationId}
                messageList={filterCampaignToMessageDetails[pageFilter].messages}
                allMessagesCount={filterCampaignToMessageDetails[pageFilter].count}
                eachPageMessagesCount={filterCampaignToMessageDetails[pageFilter].messages?.length}
                loading={filterCampaignToMessageDetails[pageFilter].loading}
                channel={filterCampaignToMessageDetails[pageFilter].channel}
                setPageParams={setPageParams}
                pageParams={pageParams}
                pageFilter={pageFilter}
            />
        )
    }

    return (
        <ProactiveMessagesBox
            source={source}
            organizationId={organizationId}
            messageList={filterCampaignToMessageDetails[pageFilter].messages}
            allMessagesCount={filterCampaignToMessageDetails[pageFilter].count}
            eachPageMessagesCount={filterCampaignToMessageDetails[pageFilter].messages?.length}
            loading={filterCampaignToMessageDetails[pageFilter].loading}
            channel={filterCampaignToMessageDetails[pageFilter].channel}
            setPageParams={setPageParams}
            pageParams={pageParams}
            pageFilter={pageFilter}
            onSortChange={handleSortChange}
            orderBy={orderBy}
            sortBy={sortBy}
        />
    )
}